import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { GetVatRatesResponseInterface } from '../definitions/get-vat-rates-response.interface';
import { GetVatRatesQueryParamsInterface } from '../definitions/get-vat-rates-query-params.interface';
import { createQueryParams } from './get-vat-rates-query-params-factory';
import { ConfigService } from '../../../config/config.service';

@Injectable()
export class GetVatRatesService {

    private apiUrl: string = this.configService.config.rest.apiV2Url;

    constructor(private client: HttpClient, private configService: ConfigService) {}
  
    public getVatRates(paramsObj: GetVatRatesQueryParamsInterface): Observable<Array<GetVatRatesResponseInterface>> {
      const url = `${this.apiUrl}/vat-rates`;

      const params: HttpParams = createQueryParams(paramsObj);
  
      return this.client.get<Array<GetVatRatesResponseInterface>>(url, { params }).pipe(
        catchError(error => throwError(handleProblem(error)))
      );
    }
}
